import React, { Component } from 'react';
import Mailto from 'react-mailto.js';
import Fade from 'react-reveal/Fade';

class Grow extends Component {
  render() {
    return (
      <div className="grow">

        <Fade left cascade>
        <div className="text-container">
          <h2>We need your help to grow!</h2>
          <h3>A little seed can grow into a big tree</h3>
          <h3>
            <Mailto
              secure={true}
              to='Invest@whofolio.com'
              subject="I can help Whofolio grow!">
              Invest today &rarr;
            </Mailto>
          </h3>
        </div>
        </Fade>

      </div>
    );
  }
}

export default Grow;



// WEBPACK FOOTER //
// ./src/assets/components/grow.js